(function () {
  function getRoot() { return document.querySelector('[data-mb-libd-root]'); }

  function openDrawer() {
    var root = getRoot();
    if (!root) return;
    root.classList.add('is-open');
    document.body.classList.add('mb-libd-lock');
    var panel = root.querySelector('.mb-libd__drawer');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('mb-libd-lock');
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- Live search over the rendered catalog ----------
  var searchIndex = null;

  function buildSearchIndex() {
    var root = getRoot();
    if (!root) return [];
    var index = [];
    root.querySelectorAll('.mb-libd__list > .mb-libd__group').forEach(function (gh) {
      var group = gh.textContent.trim();
      var node = gh.nextElementSibling;
      while (node && node.classList.contains('mb-libd__rowgroup')) {
        var rl = node.querySelector('.mb-libd__row-link');
        if (rl) {
          var cat = rl.textContent.trim();
          var href = rl.getAttribute('href');
          index.push({ name: cat, bc: group, href: href, q: (cat + ' ' + group).toLowerCase() });
          node.querySelectorAll('.mb-libd__subrow').forEach(function (s) {
            index.push({
              name: s.textContent.trim(),
              bc: group + ' › ' + cat,
              href: s.getAttribute('href'),
              q: (s.textContent + ' ' + cat + ' ' + group).toLowerCase()
            });
          });
        }
        node = node.nextElementSibling;
      }
    });
    return index;
  }

  function runSearch(query) {
    var root = getRoot();
    if (!root) return;
    var main = root.querySelector('[data-mb-libd-main]');
    var results = root.querySelector('[data-mb-libd-results]');
    if (!main || !results) return;

    var q = query.trim().toLowerCase();
    if (!q) {
      results.hidden = true;
      main.hidden = false;
      results.innerHTML = '';
      return;
    }

    main.hidden = true;
    results.hidden = false;

    if (!searchIndex) searchIndex = buildSearchIndex();
    var hits = searchIndex.filter(function (it) { return it.q.indexOf(q) > -1; });

    if (!hits.length) {
      results.innerHTML = '<div class="mb-libd__empty">No categories match “' + escapeHtml(query) + '”.</div>';
      return;
    }

    results.innerHTML = hits.slice(0, 60).map(function (it) {
      return '<a class="mb-libd__hit" href="' + it.href + '"><span class="mb-libd__hit-name">' + escapeHtml(it.name) + '</span><span class="mb-libd__hit-bc">' + escapeHtml(it.bc) + '</span></a>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mb-libd-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest('[data-mb-libd-close]')) {
      closeDrawer();
      return;
    }

    var toggleBtn = e.target.closest('[data-mb-libd-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      toggleBtn.closest('.mb-libd__rowgroup').classList.toggle('is-open');
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-mb-libd-search]')) runSearch(e.target.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var root = getRoot();
    if (root && root.classList.contains('is-open')) closeDrawer();
  });
})();
